
export  const viewMoreUrls = {
  'Cooking': '/cooking-games',
  'Exclusive': '/exclusive-games',
  'New Games': '/new-games',
  'Fighting':'/fighting-games',
  'Christmas':'/christmas-games',
  'Halloween':'/halloween-games',
  'Doctor':'/doctor-games',
  'Dino Games':'/dino-games',
  'Snake Games':'/snake-games',
  'Mahjong Games':'/mahjong-games',
  'Roblox Games':'/roblox-games',
  'Toca boca Games':'/toca-boca',
  'Card Games':'/card-games',
  'Papas Games':'/papas-games',
  'Barbie Games':'/barbie-games',
  'Fnf Games':'/fnf-games',
  'Io Games':'/io-games',
  'Shooting Games':'/shooting',
  'Racing': '/racing-games',
  'Puzzle': '/puzzle-games',
  'Action': '/action-games',
  'Girl games': '/girl-games',
};